import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OtpComponent } from 'src/app/components/otp/otp.component';
import { DatePipe, formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';

import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss'],
})
export class BookingDetailsComponent {
  currentDate: Date;
  notfound: boolean = false;
  bookingId: string = "";
  userData: any;
  bookingDetails: any;
  filteredApplicants: any;
  booking_details: any;
  applicants: any;
  applicant: any;
  formElement: any;
  booking_details_storage: any;
  participant: any;
  phone: any;
  name: any;
  email: any;
  purpose: any;
  storedData: any;
  booking_storage_token: any;
  type: any;
  applicantData: any;
  isResend = false;
  isRescheduleOrCancel = false;
  formBookingDetails: any;
  theCurrentDate: any;
  theSlotDate: any;
  isDatePassed: boolean = false;

  @ViewChild('successDialog') successCall!: TemplateRef<any>;
  isSuccess: boolean = false;
  applicantCount: any;

  constructor(private route: ActivatedRoute, private datePipe: DatePipe,
    private apiService: ApiService, public dialog: MatDialog, private storage: StorageService, private snackBar: MatSnackBar, private router: Router, private spinner: NgxSpinnerService) {
    this.currentDate = new Date();
  }

  // Function for otp dialog component
  openDialog(purpose: any, type: any, participant: any, bookingId: any) {
    // ToDo:Need to implement API Call for the OTP here
    const dialogRef = this.dialog.open(OtpComponent, {
      height: '370px',
      width: '400px',
      data: { purpose: purpose, type: type, participant: participant, bookingId: bookingId, applicantData: this.applicantData, formBookingDetails: this.formBookingDetails }, disableClose: true,
    });
    const subscribeResend = dialogRef.componentInstance.resendEvent.subscribe((data) => {
      this.isResend = data;
      // this.resendOtp();
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  // Cancel Entire Booking Function
  cancelEntireBooking() {
    this.participant = this.storage.get('km_participant_id');
      this.storedData = {
        booking_id: this.booking_details.id
      };

      // mat spinner 
      this.spinner.show();
      this.apiService.cancelEntireAppointment(this.storedData).subscribe({
        next: (response: any) => {
          if (response.success === true) {
            this.spinner.hide();
            this.snackBar.open(response.message, '', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: ['green-snackbar']
            });
            this.spinner.hide();
            this.router.navigate(['/booking-list']);
          }else {
            this.snackBar.open(response.message, '', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: ['green-snackbar']
            });
            this.spinner.hide();
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.snackBar.open(err.message, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'green-snackbar'
          });
        },
        complete: () => { }
      });

  }

  // Reschedule Entire Booking Function
  rescheduleEntireBooking() {
    // mat spinner 
    this.spinner.show();
    this.applicantCount = this.booking_details?.totalapplicants;
    this.storage.set('km_applicant_count', JSON.stringify(this.applicantCount));

    // ToDo:Need to implement Booking Cancel
    this.participant = this.storage.get('km_participant_id');
    this.purpose = "Reschedule";
    this.bookingId = this.booking_details_storage.id;
    this.participant = this.participant;
    this.type = "entireReschedule";
    this.storedData = {
      participant: this.participant,
      phone: this.booking_details_storage.phone,
      purpose: "Reschedule",
      name: this.booking_details_storage.name,
      email: this.booking_details_storage.email
    };
    let rescheduleData = {
      bookingData: this.booking_details
    };
    this.storage.set('km_reschedule_data', JSON.stringify(rescheduleData));

    

    
    this.router.navigate(['/reschedule-appointment']);

    this.spinner.hide();

    


  }



  ngOnInit() {
    this.spinner.show();
    this.route.params.subscribe(params => {
      this.bookingId = params['bookingNumber'];
      this.booking_details_storage = JSON.parse(this.storage.get('med_participant_booking_details') || '[]');
      if (this.bookingId) {
        this.spinner.show();
        
        this.apiService.getBookingIdDetails(this.bookingId).subscribe({
          next: (response: any) => {
            if (response.success === true) {
              this.spinner.hide();
              this.booking_details = response.data;
              this.isSuccess = true;

              //Checking whether booking date is passed or not
              // this.theCurrentDate = formatDate(this.currentDate, 'yyyy-MM-dd', 'en_US');
              // this.theSlotDate = formatDate(this.booking_details.slot.start_time, 'yyyy-MM-dd', 'en_US');

              this.theCurrentDate = formatDate(this.currentDate, 'yyyy-MM-dd HH:mm:ss', 'en_US');
            this.theSlotDate = formatDate(this.booking_details.slot.start_time, 'yyyy-MM-dd HH:mm:ss', 'en_US');

              // if (this.theCurrentDate > this.theSlotDate) {
              //   this.isDatePassed = true;
              // } else {
              //   this.isDatePassed = false;
              // }

              if (new Date(this.theCurrentDate) < new Date(this.theSlotDate)) {
                this.isDatePassed = false;
              } else {
                this.isDatePassed = true;
              }

            }
          },
          error: (err: any) => {
            this.spinner.hide();
          },
          complete: () => { this.spinner.hide();}
        });
      } else {
        
      }
    });

    


    //Checking whether all the applicants are rescheduled or cancelled
    this.isSuccess = this.booking_details?.applications[0]?.applicants.some((applicant: any) => applicant.cancel_success === false && applicant.is_rescheduled === false);
    if (typeof this.isSuccess === 'undefined' || this.isSuccess === true) {
      this.isSuccess = true;
    }else {
      this.isSuccess = false;
    }
  }

  //return name from the custom form element
  getApplicantName(formElements: any) {
    let obj = formElements.filter((t: any) => t.field_name === "givenname")[0];
    return obj.field_value;
  }


}



